import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutModule } from './layout/layout.module';
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatFormFieldDefaultOptions
} from '@angular/material/form-field';
import { PopoverModule } from './components/popover/popover.module';
import { HighlightModule } from './components/highlight/highlight.module';
import { PageLayoutModule } from './components/page-layout/page-layout.module';
import { BreadcrumbsModule } from './components/breadcrumbs/breadcrumbs.module';

@NgModule({
  imports: [
    CommonModule,
    LayoutModule,
    PopoverModule,
    HighlightModule,
    PageLayoutModule,
    BreadcrumbsModule
  ],
  exports: [LayoutModule, PageLayoutModule, BreadcrumbsModule],
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        appearance: 'fill'
      } as MatFormFieldDefaultOptions
    }
  ]
})
export class VexModule {}
